/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MarketplaceDTOFromJSON, MarketplaceDTOToJSON, } from './MarketplaceDTO';
/**
 * Check if a given object implements the UserMarketplaceResponseDTO interface.
 */
export function instanceOfUserMarketplaceResponseDTO(value) {
    return true;
}
export function UserMarketplaceResponseDTOFromJSON(json) {
    return UserMarketplaceResponseDTOFromJSONTyped(json, false);
}
export function UserMarketplaceResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'marketplaceDTO': json['marketplaceDTO'] == null ? undefined : MarketplaceDTOFromJSON(json['marketplaceDTO']),
    };
}
export function UserMarketplaceResponseDTOToJSON(json) {
    return UserMarketplaceResponseDTOToJSONTyped(json, false);
}
export function UserMarketplaceResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'marketplaceDTO': MarketplaceDTOToJSON(value['marketplaceDTO']),
    };
}
